// src/components/layouts/AdminLayout.tsx
import { Outlet } from 'react-router-dom';
import AdminSidebar from '@/components/navigation/AdminSidebar';
import FloatingActionButton from '@/components/ui/FloatingActionButton';
import { AlertNotifications } from '@/components/ui/AlertNotifications';

export default function AdminLayout() {
  return (
    <div className="flex h-screen bg-muted"> 
      <AdminSidebar />      
      <div className="flex-1 flex flex-col overflow-hidden">
        <main className="flex-1 overflow-y-auto bg-background p-4 md:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
      <FloatingActionButton />
      <AlertNotifications />
    </div>
  );
}